import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#15B686",
      stroke: "#15B686",
      "stroke-linejoin": "round",
      "stroke-width": "1.2",
      d: "M7 3h4.91l-3 3.85H13L6.455 14l1.363-5.225H4z"
    }, null, -1)
  ])))
}
export default { render: render }